import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

// navigator.onLine through the online and offline events (merchant screens §4.3). Back online, every active query
// refetches; nothing is queued while offline (D-061).
export function useOnline(): boolean {
  const queryClient = useQueryClient();
  const [online, setOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const goOffline = () => setOnline(false);
    const goOnline = () => {
      setOnline(true);
      void queryClient.invalidateQueries({ refetchType: 'active' });
    };
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, [queryClient]);

  return online;
}
